A salary or compensation range for a position.
